import { render, staticRenderFns } from "./specialTasksGrade.vue?vue&type=template&id=35467d6e&"
import script from "./specialTasksGrade.vue?vue&type=script&lang=js&"
export * from "./specialTasksGrade.vue?vue&type=script&lang=js&"
import style0 from "./specialTasksGrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports